import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { Row, Col, Steps, Form, Input, Checkbox, Icon, Button } from 'antd'

import './index.css'
import Logo from 'assets/images/ekko-logo.png'

import UndrawApplication from 'assets/images/onboarding/messaging-application.svg'
import RightContent from 'components/OnboardingNow/RightContent'

import { ORIGIN_NOW } from '../../redux/Admin/constants'
import { requestSignup } from '../../redux/Admin/actions'

const FormItem = Form.Item
const { Step } = Steps

class RegisterNow extends React.Component {
    handleSubmit = e => {
        const { requestSignup } = this.props

        e.preventDefault()
        this.props.form.validateFields((err, { organization, email, password }) => {
            if (!err) {
                requestSignup({ organization, email, password, origin: ORIGIN_NOW })
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { isLoading } = this.props

        return (
            <Row style={{ height: '100%', margin: 0 }}>
                <Col xs={24} lg={12} style={{ backgroundColor: 'white' }}>
                    <div className="form-layout">
                        <div style={{ flex: 2 }}></div>
                        <div style={{ flex: 7 }}>
                            <Row type="flex" justify="center" style={{ width: '100%' }}>
                                <Col xs={22} sm={18} md={14}>
                                    <img src={Logo} height="42" />
                                    <h2 style={{ paddingTop: 35, marginBottom: 30 }}>Sign up to Ekko</h2>
                                    <Form onSubmit={this.handleSubmit} className="onboarding-register-form">
                                        <FormItem>
                                            {getFieldDecorator('organization', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Please input your organization!'
                                                    }
                                                ]
                                            })(<Input placeholder="Organization" />)}
                                        </FormItem>

                                        <FormItem>
                                            {getFieldDecorator('email', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        type: 'email',
                                                        message: 'The input is not valid E-mail!'
                                                    }
                                                ]
                                            })(<Input placeholder="Email" />)}
                                        </FormItem>
                                        <FormItem>
                                            {getFieldDecorator('password', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Please input your Password!'
                                                    }
                                                ]
                                            })(<Input type="password" placeholder="Password" />)}
                                        </FormItem>
                                        {/* <FormItem>
                                            {getFieldDecorator('remember', {
                                                valuePropName: 'checked',
                                                initialValue: true
                                            })(<Checkbox>I accept</Checkbox>)}
                                            <Link to="/terms">
                                                <span className="gx-signup-form-forgot gx-link">Term & Conditions</span>
                                            </Link>
                                        </FormItem> */}
                                        <FormItem style={{ paddingTop: 20 }}>
                                            <Button type="primary" className="gx-mb-0" htmlType="submit">
                                                {isLoading ? <Icon type="loading" spin /> : <span>Sign Up</span>}
                                            </Button>
                                            <Link to="/signin">I already have an account</Link>
                                        </FormItem>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                        <div style={{ flex: 1 }} />
                        <div style={{ flex: 1 }}>
                            <Row type="flex" justify="center" style={{ width: '100%' }}>
                                <Col span={22}>
                                    <Steps current={0}>
                                        <Step title="In Progress" description="Create an account." />
                                        <Step title="Waiting" description="Setup your project." />
                                        <Step title="Waiting" description="Install Ekko." />
                                    </Steps>
                                </Col>
                            </Row>
                        </div>
                        <div style={{ flex: 1 }} />
                    </div>
                </Col>
                <Col xs={0} lg={12}>
                    <RightContent image={UndrawApplication} title="Ready to embed Ekko on your application ?" />
                </Col>
            </Row>
        )
    }
}

const WrappedRegisterNowForm = Form.create()(RegisterNow)

const mapStateToProps = ({ admin }) => ({
    isLoading: admin.loading.auth
})
const mapActionsToProps = dispatch => ({
    requestSignup: bindActionCreators(requestSignup, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(WrappedRegisterNowForm)
